import React, { useState } from 'react';
import { Box, Button, TextField } from '@mui/material';
import { useLazyQuery, gql } from '@apollo/client';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { LOGIN } from '../../constants/string';
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import * as Sentry from "@sentry/react";

const AUTH_QUERY = gql`
  query auth($userName: String!, $password: String!, $client: String!) {
    auth(input: { userName: $userName, password: $password, client: $client }) {
      token
      accessToken
      tokenExpiry
      accessTokenExpiry
    }
  }
`;

const UsernamePasswordLogin = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();
  const { login } = useAuth();
  const [showPassword, setShowPassword] = useState(false);

  const handleTogglePasswordVisibility = () => {
    setShowPassword((prevShowPassword) => !prevShowPassword);
  };


  const [auth, { loading, error }] = useLazyQuery(AUTH_QUERY, {
    onCompleted: (data) => {
        
      if (data.auth) {
        login(data.auth.accessToken);
        setTimeout(() => navigate('/'), 100);
      } else {
        alert('Login failed');
      }
    },
    onError: (error) => {
      console.error('Error:', error);
    },
  });

  const handleUsernameChange = (event) => {
    setUsername(event.target.value);
  };

  const handlePasswordChange = (event) => {
    setPassword(event.target.value);
  };

  const handleUsernamePasswordLogin = () => {
    Sentry.setUser({
      id: username,
      userName: username,
    });

    auth({
      variables: {
        userName: username,
        password: password,
        client: 'ondcb2c',
      },
    });
  };

  return (
    <Box
      component="form"
      noValidate
      sx={{
        mt: 1,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
      }}
    >
      <TextField
        id="username"
        placeholder="Enter Username"
        value={username}
        onChange={handleUsernameChange}
        sx={{ width: '120%' }}
      />
      <TextField
        id="password"
        placeholder="Enter Password"
        type={showPassword ? "text" : "password"}
        value={password}
        onChange={handlePasswordChange}
        sx={{ width: "120%", mt: 2 }}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                aria-label="toggle password visibility"
                onClick={handleTogglePasswordVisibility}
                edge="end"
              >
                {showPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
      <Button onClick={handleUsernamePasswordLogin} variant="contained" color="primary" sx={{ width: '120%',padding:1.4, mt: 2 }}>
        {LOGIN}
      </Button>
      {loading && <p>Loading...</p>}
      {error && <p>Error: {error.message}</p>}
    </Box>
  );
};

export default UsernamePasswordLogin;
